module.exports = __webpack_public_path__ + "static/media/PDF417.5837b287.png";